

























import { Component, Vue } from "vue-property-decorator";
import cityAtlasSrc from "@/assets/images/city-animated_atlas_.png"

@Component({})
export default class HotspotSection extends Vue {
  created() {
    (<any> window).cityAtlasSrc = cityAtlasSrc;
  }

  mounted() {
    // city animation was generated with Adobe Animate
    // the main JS files are located in public/index.html
    // dependencies are imported from there
    (<any> window).initCity();
  }
}
